import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreHeaderComponent } from './core-header/core-header.component';
import { CoreNavigationComponent } from './core-navigation/core-navigation.component';
import { UIModule } from 'app/ui/ui.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/shared/shared.module';
import { CoreFeedbackModalComponent } from './core-feedback-modal/core-feedback-modal.component';
import { CoreQuoteHeaderComponent } from './core-quote-header/core-quote-header.component';
import { CoreQuoteForwardModalComponent } from './core-quote-forward-modal/core-quote-forward-modal.component';
import { TutorialModule } from 'app/tutorial/tutorial.module';
import { CoreDialogModalComponent } from './core-dialog-modal/core-dialog-modal.component';
import { CoreRequiredWorkModalComponent } from './core-required-work-modal/core-required-work-modal.component';
import { AlertModule } from 'app/alert/alert.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CalendarModule } from 'primeng/calendar';
import { ModalModule } from 'app/modal/modal.module';
import { CoreQuoteReviewResultModalComponent } from './core-quote-review-result-modal/core-quote-review-result-modal.component';
import { CoreIntroductionComponent } from './core-introduction/core-introduction.component';
import { CoreAlertComponent } from './core-alert/core-alert.component';
import { CoreProjectHeaderComponent } from './core-project-header/core-project-header.component';
import { CoreBlockQuoteLimitUsersComponent } from './core-block-quote-limit-users/core-block-quote-limit-users.component';
import { CoreCookieConsentComponent } from './core-cookie-consent/core-cookie-consent.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { EditorModule } from '@tinymce/tinymce-angular';
import { CoreAttentionWidgetComponent } from './core-attention-widget/core-attention-widget.component';
import { CoreAttentionComposerComponent } from './core-attention-composer/core-attention-composer.component';

@NgModule({
	declarations: [
		CoreHeaderComponent,
		CoreNavigationComponent,
		CoreFeedbackModalComponent,
		CoreQuoteHeaderComponent,
		CoreQuoteForwardModalComponent,
		CoreDialogModalComponent,
		CoreRequiredWorkModalComponent,
		CoreQuoteReviewResultModalComponent,
		CoreIntroductionComponent,
		CoreAlertComponent,
		CoreProjectHeaderComponent,
		CoreBlockQuoteLimitUsersComponent,
		CoreCookieConsentComponent,
		CoreAttentionWidgetComponent,
		CoreAttentionComposerComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		UIModule,
		SharedModule,
		TutorialModule,
		AlertModule,
		NgbModule,
		CalendarModule,
		ModalModule,
		DragDropModule,
		EditorModule
	],
	exports: [
		CoreHeaderComponent,
		CoreNavigationComponent,
		CoreDialogModalComponent,
		CoreRequiredWorkModalComponent,
		CoreAttentionWidgetComponent,
		CoreIntroductionComponent,
		CoreAlertComponent,
		CoreBlockQuoteLimitUsersComponent,
		CoreCookieConsentComponent
	]
})
export class CoreModule { }
